import React from "react";
import { createRoot } from "react-dom/client";
import "./tailwind.css";

const App: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-50">
      <h1 className="text-4xl font-semibold tracking-tight">Hello world</h1>
    </div>
  );
};

const domNode = document.getElementById("root");

if (domNode) {
  const root = createRoot(domNode);
  root.render(<App />);
}